var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.metadata
    ? _c(
        "div",
        [
          _c("product-metadata-item", {
            attrs: { value: _vm.currentMetaData.release }
          }),
          _vm._v(" "),
          _c("product-metadata-item", {
            attrs: {
              label: _vm.designerLabel,
              value: _vm.currentMetaData.designer
            }
          }),
          _vm._v(" "),
          _c("product-metadata-item", {
            attrs: { label: _vm.sizeLabel, value: _vm.currentMetaData.size }
          }),
          _vm._v(" "),
          _c("product-metadata-item", {
            attrs: { label: _vm.pagesLabel, value: _vm.currentMetaData.pages }
          }),
          _vm._v(" "),
          _c("product-metadata-item", {
            attrs: {
              label: _vm.publicationLabel,
              value: _vm.currentMetaData.publication
            }
          }),
          _vm._v(" "),
          _c("product-metadata-item", {
            attrs: {
              label: _vm.bindingLabel,
              value: _vm.currentMetaData.binding
            }
          })
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }